namespace Areas.Dailies {
    "use strict";


    export function goBack() {
        window.history.back();
    }


    export function gotoDailyReportListFromForm() {
        var keyId: any = $('#DailiesForm').dxForm('instance').option('ProjectId');
        if (keyId != null) {
            var linkInfo = "/Dailies/List/Index/" + keyId.toString() + "";
            location.href = linkInfo;
        }
        else {
            DevExpress.ui.notify("Record not selected!", "warning", 2000);
        }
    }

    export function gotoEditFromForm() {
        var keyId: any = $('#DailiesForm').dxForm('instance').option('KeyId');
        if (keyId != null) {
            var linkInfo = "/Dailies/Edit/Index/" + keyId.toString() + "";
            location.href = linkInfo;
        }
        else {
            DevExpress.ui.notify("Record not selected!", "warning", 2000);
        }
    }

    export function gotoViewFromForm() {
        var keyId: any = $('#DailiesForm').dxForm('instance').option('KeyId');
        if (keyId != null) {
            var linkInfo = "/Dailies/View/Index/" + keyId.toString() + "";
            location.href = linkInfo;
        }
        else {
            DevExpress.ui.notify("Record not selected!", "warning", 2000);
        }
    }



    export function gotoCreate(e) {

        const selectTemplateDialog = new Areas.Dialogs.SelectTemplate.SelectTemplateDialog(dialogClosing);
    }

    function dialogClosing(dialogResult: DialogResult, data: any) {

        if (dialogResult === DialogResult.Cancel) {
            return;

        }

        const dataGrid: any = $("#DailyReportGrid").dxDataGrid("instance");
        let projectId: any = dataGrid.option('projectId');
        let inspectorLk: any = dataGrid.option('inspectorLk');


        let baseURL = "/Dailies/Create/PostDailyReportWithTemplate"
       
        var newData = JSON.stringify(
            {
                "inspectionProjectId": projectId,
                "inspectorLk": inspectorLk,
                "reportNotes": data,
                "status": "Draft"
            });

        sendRequest(`${baseURL}`,
            newData,
            "POST");

        Areas.refreshGrid("DailyReportGrid");


    }

    export function gotoEdit() {
        var dataGrid = $('#DailyReportGrid').dxDataGrid('instance');
        var dataId = dataGrid.getSelectedRowKeys()[0];
        if (dataId != null) {
            var linkInfo = "/Dailies/Edit/Index/" + dataId.toString() + "";
            location.href = linkInfo;
        }
        else {
            DevExpress.ui.notify("You need to select a row first!", "warning", 2000);
        }
    }

    export function gotoView() {
        var dataGrid = $('#DailyReportGrid').dxDataGrid('instance');
        var dataId = dataGrid.getSelectedRowKeys()[0];
        if (dataId != null) {
            var linkInfo = "/Dailies/View/Index/" + dataId.toString() + "";
            location.href = linkInfo;
        }
        else {
            DevExpress.ui.notify("You need to select a row first!", "warning", 2000);
        }
    }

    export function viewLink(cellElement, cellInfo) {
        var fieldData = cellInfo.data.dailyReportId;
        var linkInfo = "<a href= '/Dailies/View/Index/" + String(fieldData) + "'>View</a>"
        cellElement.html(linkInfo);
    }


    export function status(cellElement, cellInfo) {

        cellElement.html(cellInfo.data.status);

        if (cellInfo.data.status == 'Open') {
            $(cellElement).css('background-color', 'gold');


        }
    }

    export function resendEmail() {
        var keyId: any = $('#DailiesForm').dxForm('instance').option('KeyId');
        if (keyId != null) {
            sendRequest(`/Dailies/Edit/ResendDailyEmail/${keyId}/`, "", "PUT");
        }
        else {
            DevExpress.ui.notify("Record not selected!", "warning", 2000);
        }
    }

    export function resendEmailFromList() {
        var keyId: any = $('#DailyReportGrid').dxDataGrid('instance').getSelectedRowKeys();
        if (keyId[0] != null) {
            sendRequest(`/Dailies/Edit/ResendDailyEmail/${keyId[0]}/`, "", "PUT");
        }
        else {
            DevExpress.ui.notify("Record not selected!", "warning", 2000);
        }
    }

}

